module.exports = "<div class=_wrapper> <div class=holding-special-banner> <div class=holding-special-banner__close-container ng-if=canClose ng-click=onClose()> <svg class=holding-special-banner__close-icon> <use xlink:href=#cross-icon></use> </svg> </div> <div class=holding-special-banner__container ng-transclude></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/promotions/directives/promotion-banner/promotion-banner.html
// module id = 797
// module chunks = 0